import type { IconDefinition } from '../index.tsx';

export const iconEthereum: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconEthereum',
  icon: [
    16,
    16,
    [],
    '',
    'M8 10L14 7L9 0H7L2 7L8 10Z M8 12.2361L2.26233 9.36722L7.00002 16L9.00002 16L13.7377 9.36719L8 12.2361Z',
  ],
};
